import React from "react";
import { Controller, Control, FieldError } from "react-hook-form";
import ErrorMessage from "../../../components/text/ErrorMessage";
import { DropdownList } from "react-widgets";
import { FormProps } from "./proposal-preview";
import { ProposalReason } from "../../../core";

interface Props {
  handleSubmit: (callback: (data: any) => void) => (event: React.FormEvent<HTMLFormElement>) => void;
  changeStatus: (data: any) => void;
  control: Control<FormProps>;
  reasons: ProposalReason[];
  reason?: FieldError | undefined;
  updating?: boolean;
  setStatusModalOpen: (data: any) => void;
}

const ProposalRejectModal: React.FC<Props> = (props) => {

  return (
    <>
      <div className="modal fade show in" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{
        zIndex: 1052
      }}>
        <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
          <div className="modal-content rounded-0">
            <div className="modal-body text-center">
              <form onSubmit={props.handleSubmit(props.changeStatus)}>
                <div className="container">
                  <div className="row">
                    <div className="col">
                      <p>Are you sure to Reject the unit / Property</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div className="form-group font-weight-semibold mb-3 text-left">
                        <label htmlFor="" className="font-sm text-uppercase">
                          Reason<span className="text-danger">*</span>
                        </label>
                        <Controller control={props.control} name="reason" rules={{
                          required: true
                        }} render={({
                          onChange,
                          value
                        }) => <DropdownList value={value} data={props.reasons} defaultValue={value} textField={"reason"} valueField={"reason"} placeholder={"Select Reason"} onChange={val => {
                          onChange(val.reason);
                        }} />} />
                        {props.reason && <ErrorMessage>Reason is required</ErrorMessage>}
                      </div>

                      <div className="form-group font-weight-semibold mb-3 text-left">
                        <label htmlFor="" className="font-sm text-uppercase">
                          Comments
                        </label>
                        <Controller control={props.control} name="comment" render={({
                          onChange,
                          value,
                          name
                        }) => <input type="text" className="form-control rounded-sm font-weight-semibold" placeholder="Enter comment" name={name} value={value} onChange={onChange} id="comment" />} />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-auto mr-auto">
                      <button className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-md-5 px-4 mr-3" onClick={() => {
                        props.setStatusModalOpen({});
                      }} disabled={props.updating}>
                        Cancel
                      </button>
                    </div>
                    <div className="col-auto">
                      <button className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill" disabled={props.updating} type='submit' // onClick={() => {
                      //   changeStatus();
                      // }}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1051 }}
      ></div>
    </>

  );
}

export default ProposalRejectModal;


